
<template>
  <div>
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  },
  created() {
    // if (this.$router.history.current.path == '/financial') {
    //   this.$router.push({path: '/financial/invoiceApplyFor'})
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/financial/financial.vue